import { motion } from "framer-motion";
import { ReactNode } from "react";

type AnimatedSectionProps = {
    children: ReactNode;
    delay?: number;
};

export const AnimatedSection = ({
    children,
    delay = 0,
}: AnimatedSectionProps) => {
    return (
        <motion.div
            initial={{ y: 20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 0.5, delay }}
        >
            {children}
        </motion.div>
    );
};
